var shop_currency_default = $('#shop_currency_val').text();
function myCartSection() {
  var SideContentHeight = $('.cart-side-panel .block-cart-header').height();
  $('#cart_container_id').css('top', SideContentHeight + 'px');  
}



jQuery(window).resize(function(){
  myCartSection();
});
var shop_currency;
if(typeof $.cookie('currency') === 'undefined'){
  shop_currency = shop_currency_default;
} else{
  shop_currency = $.cookie('currency');
}
var wc_theme_source = {
  lib:{
    ajax_error: function(error, message, this_click){

      var data = eval('('+error.responseText+')');
      if(!!data.message){        
        if(this_click == 'grid_click'){          
          var itrmCount = data.description.split(' ')[1];
          jQuery('.cartCount_item').text(itrmCount);
          jQuery('#cart_error_message').find('h5').text(data.description);         
          setTimeout(function(){
            $("#cart_modal_popup.in").css('opacity','0');
            $("#cart_error_message").modal('show');
          },500);         
        }else{
          jQuery('.responseJSON_Error').find('h5').text(data.description);
          jQuery('.responseJSON_Error').show();
        }
      }
    },
    on_cart_update: function(item){
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {          
          if(cart.item_count > 0){

            $.each(cart.items, function(index, item){
              var cart_handle = item.handle;
              var storage_val = localStorage[cart_handle];          

            });
          }

          $('.cart_qty_cls').html(cart.item_count);          
          var shop_currency = '';
          //jQuery('.shop_cart span.title span').html(Shopify.formatMoney(cart.total_price, shop_currency));

          if(cart.item_count > 0){
            var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
            if($('.items_carts span').hasClass('money')){
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            } else{
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            }
          }else{
            $('.items_carts span').remove();
            $('.items_carts').html("<span class='money'>$0.00</span>");
          }
          setTimeout(function(){

            myCartSection();            
          },600);
        });
      },100);
    },
    on_item_added: function(item,sku){      
      $('.cart-popup-item-image').html('<img src="'+ item.featured_image.url +'" alt="'+ item.featured_image.alt +'" class="cart-popup-item-image" />');
     
      $('.cart-popup-item-title').html('<a href="'+ item.url +'">'+ item.product_title +'</a>'); 
// 		if(sku != ''){ $('.cart-popup-item-title').append('<span>'+ sku +'</span>')}
      
      
      $('.cart-popup-item-prices').html('<span class="money">'+Shopify.formatMoney(item.price, shop_currency_default)+'</span>');
      var cart_options_values = '';
      $.each(item.options_with_values, function(index, item){        
        if(item.name != "Title" ){
          cart_options_values += '<li>';       
          var cartname = item.name;
          var downcasename = cartname.toLowerCase();
          if(downcasename == 'product_colour'){
            cart_options_values += '<span class="cov-label">Color:</span><span class="cov-text">'+ item.value +'</span>'; 
          }
          else if(downcasename == 'product_size'){
            cart_options_values += '<span class="cov-label">Size:</span><span class="cov-text">'+ item.value +'</span>'; 
          }
          else if(downcasename == 'doors_tunnel_options'){
            cart_options_values += '<span class="cov-label">Tunnel:</span><span class="cov-text">'+ item.value +'</span>'; 
          }
          else if(downcasename == 'stimulation_levels'){
            cart_options_values += '<span class="cov-label">Stimulation:</span><span class="cov-text">'+ item.value +'</span>'; 
          }
          else{
            cart_options_values += '<span class="cov-label">'+ cartname.replace('product_','') +' :</span><span class="cov-text">'+ item.value +'</span>';       
          }  
          cart_options_values += '</li>';
        }
      });
      $('ul.cart-popup-option').html(cart_options_values);            
      $.ajax({
        type: 'GET',
        url: '/products/'+item.handle,
        dataType: "html",
        success: function(data){
          var cart_related_pro = $(data).find('.product-tabs-wrapper ul.product-feature-slider').html();
          var cart_related_pro_length = $(data).find('.product-tabs-wrapper ul.product-feature-slider li').length;          
          if( cart_related_pro_length > 0 ){          
            $('ul.cart-popup-related-product').html(cart_related_pro);
            $('.cart-popup-bottom').removeClass('hide');
          }
        }
      }); 
      ajaxCart.load();
      // wc_theme_source.lib.on_cart_update(item);
    },
    on_product: function(e){
      alert("Received everything we ever wanted to know about " + e.title);
    },
    addtocart_product: function(id, qty, callback,this_click){
      var qty = qty || 1;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + id,
        dataType: "json",
        success: function(item){
          if(window.location.href.indexOf("/cart") > -1){
            location.reload();
          } else{
            if((typeof callback) === 'function'){
              callback(item, id);
            } else{
              wc_theme_source.lib.on_item_added(item);
            }
            setTimeout(function(){             
              $("#cart_modal_popup").modal('show');         
            },500);           
          }
        },

        error: function(XMLHttpRequest, textStatus){
          if((typeof errorCallback) === 'function'){
            errorCallback(XMLHttpRequest, textStatus);
          } else{
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
          }
        }



      };
      jQuery.ajax(ajax);
    },
    get_product: function(handle, callback){
      jQuery.getJSON("/products/" + handle + ".js", function(product, n){
        wc_theme_source.lib.on_product(product);
      });
    },
    get_cart: function(callback){
      jQuery.getJSON("/cart.js", function(cart, textstatus){
        if((typeof callback) === 'function'){
          callback(cart);          
        } else{
          wc_theme_source.lib.on_cart_update(cart);         
        }
      });
    },
    addtocart_form: function(form_id, callback, errorCallback, this_click,sku){
      var ajax = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery('#' + form_id).serialize(),
        dataType: 'json',
        beforeSend: function(){
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, form_id);
          } else{
            wc_theme_source.lib.on_item_added(item,sku);
          }
          setTimeout(function(){            
            $("#cart_modal_popup").modal('show');          
          },500);
        },
         error: function(jqXHR){
          var response = eval('(' + jqXHR.responseText + ')').description;
          if($('#'+form_id).find('.error_message').length < 1){
            $('#'+form_id).find('input[type="submit"], button[type="submit"]').after("<p class='error_message' style='color:red;margin-top:5px;'>"+ response+"</p>")
            $('#'+form_id).find('.error_message').fadeIn('slow', function(){
              $('#'+form_id).find('.error_message').delay(2000).fadeOut(); 
            });
          }
          else{
            $('#'+form_id).find('.error_message').html(response);
            $('#'+form_id).find('.error_message').fadeIn('slow', function(){
              $('#'+form_id).find('.error_message').delay(2000).fadeOut(); 
            });
          }
        }
      };
      jQuery.ajax(ajax);
    },
    cart_change_item: function(line, qty, callback){
      var ajax = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&line=' + line,
        dataType: 'json',
        success: function(cart){          
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_remove_item: function(line, callback){
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + line,
        dataType: "json",
        beforeSend: function(){
          jQuery('.cart_loader_cls_id').show();
        },
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          jQuery('.cart_loader_cls_id').hide();
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_clear_all: function(){
      var ajax = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    update_cart_form: function(form){
      var ajax = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + form).serialize(),
        dataType: "json",
        beforeSend: function(){
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    }
  }
}
jQuery(document).on('click', '.add_to_cart_btn_cls', function(){
  var this_click = $(this).data('click');
  var sku = $(this).attr('data-sku');
  var temp_form_id = jQuery(this).closest('form').attr('id');
  var var_id = $('#'+temp_form_id).find('[name="id"]').val();
  var quantity = 1;
   if(this_click == 'grid_click'){   
  var var_inventory = parseInt($('#'+temp_form_id).find('[name="id"]').attr('data-inventory'));
     
   }
  else{
  var selector = $('#'+temp_form_id).find('[name="id"]');
   var var_inventory =  parseInt(selector.find('option[value="'+var_id+'"]').attr('data-inventory'));
    quantity = $('#'+temp_form_id).find('[data-quantity-input]').val();
  }
  
  jQuery.getJSON('/cart.js', function(cart) {
    var avalvar = cart.items.filter(p => p.id == var_id)[0];
    if(avalvar == undefined){
    var avalvarqty = 0; 
    }
    else{
    var avalvarqty = avalvar.quantity; 
    }
    
      if(var_inventory < (parseInt(avalvarqty) + parseInt(quantity))){
        if($('#'+temp_form_id).find('.error_message').length < 1){
          $('#'+temp_form_id).find('input[type="submit"], button[type="submit"]').after("<p class='error_message' style='color:red;margin-top:5px;'>Sorry only "+ var_inventory +" in stock</p>")
          $('#'+temp_form_id).find('.error_message').fadeIn('slow', function(){
            $('#'+temp_form_id).find('.error_message').delay(2000).fadeOut(); 
          });
        }
        else{
          $('#'+temp_form_id).find('.error_message').html("Sorry only "+ var_inventory +" in stock");
          $('#'+temp_form_id).find('.error_message').fadeIn('slow', function(){
            $('#'+temp_form_id).find('.error_message').delay(2000).fadeOut(); 
          });
        }
        
      }
      else{
       wc_theme_source.lib.addtocart_form(temp_form_id, '', '', this_click,sku);
      }
 
  });

  return false;
});

jQuery(document).on('click', '.cart_add_btn', function(){
  var this_click = $(this).data('click');
  var temp_variant_id = jQuery(this).attr('data-id');
  var temp_qty = 1;
  wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
  return false;
});



jQuery(document).ready(function(){
  ajaxCart.load();

  $('#cart_error_message').on('hidden.bs.modal', function () {
    $("#cart_modal_popup.in").css('opacity','1');
  })

});	

$(window).load(function(){
  if($('.address_ul').length>0){
    $('html, body').animate({
      scrollTop: ( $('.btn_grp').offset().top - 150 )
    }, 500);
  }
});
